import { Box, Typography, TypographyProps } from '@mui/material';
import { LngLatLike } from 'mapbox-gl';

import { SpotterLocation } from '@/common/types';
import { CopyButton } from '@/components/CopyButton';
import { lngLat } from '@/utils';

function formatCoord(
    coordinate: number,
    type: 'lat' | 'lng',
    { decimalPlaces = 1, showSecs }: { decimalPlaces?: number; showSecs?: boolean } = {}
) {
    const absolute = Math.abs(coordinate);
    const degrees = Math.floor(absolute);
    let minutes: string | number = (absolute - degrees) * 60;
    let seconds = '';
    if (showSecs) {
        minutes = Math.floor(minutes);
        seconds = `${(((absolute - degrees) * 60 - minutes) * 60).toFixed(decimalPlaces)}" `;
    } else {
        minutes = minutes.toFixed(decimalPlaces);
    }
    const direction = type === 'lat' ? (coordinate >= 0 ? 'N' : 'S') : coordinate >= 0 ? 'E' : 'W';
    return <Box component="span" sx={{ whiteSpace: 'nowrap' }}>{`${degrees}° ${minutes}' ${seconds}${direction}`}</Box>;
}

export type LatLongProps = {
    coord: LngLatLike | SpotterLocation;
    options?: { showSecs?: boolean };
};

export const LatLong = ({ coord, options = {}, sx, ...props }: LatLongProps & TypographyProps) => {
    const { lng, lat } = lngLat(coord);
    return (
        <Typography sx={{ wordSpacing: '-1px', ...sx }} {...props}>
            {formatCoord(lat, 'lat', options)}, {formatCoord(lng, 'lng', options)}{' '}
            <CopyButton sx={{ mx: '-4px' }} text={`${lat}°,${lng}°`} />
        </Typography>
    );
};
